import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import FluigService from "../../../../services/resource/fluigComprasService";
import { Loading } from "../../../../componentes/loading/loading";

export default function ResumoDepartamento({ dataInicial, dataFinal, filtrar, openModal }) {
  const service = new FluigService();
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [valoresNF, setValoresNF] = useState([]);
  const [tamanho, settamanho] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    service
      .resumoPorDepartamento(dataInicial, dataFinal)
      .then((response) => {
        const data = response?.data ?? [];
        settamanho(data.length);

        const labels = data.map((item) => item.nome || "—");
        const values = data.map((item) =>
          Number(item.totalSolicitacoes) ? Number(item.totalSolicitacoes) : 0
        );
        const valoresFormatados = data.map((item) => item.valor || "");

        setValoresNF(valoresFormatados);

        setChartOptions({
          chart: {
            type: "pie",
            events: {
              dataPointSelection: (event, chartContext, config) => {
                const index = config.dataPointIndex;
                const label = labels[index];
                openModal(label, "departamento");
              },
            },
          },
          labels,
          legend: {
            position: "bottom",
          },
            stroke: {
        show: false,
        width: 0,
      },
          tooltip: {
            custom: ({ series, seriesIndex }) => {
              const total = series[seriesIndex];
              const valorNF = valoresNF[seriesIndex] || "";
              return `
                <div style="padding: 8px;">
                  <strong>${total} solicitações</strong><br/>
                  Valor Gasto: ${valorNF}
                </div>
              `;
            },
          },
          colors: [
            "#64748B",
            "#F97316",
            "#14B8A6",
            "#3B82F6",
            "#f4f801ff",
            "#f016a7ff",
            "#c5c222ff",
          ],
        });

        setChartSeries(values);
      })
      .catch((err) => console.error("Erro ao buscar API:", err))
      .finally(() => setLoading(false));
  }, [filtrar]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:col-span-1">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Solicitações por Departamento
      </h3>
      <label className="text-muted-foreground text-sm">
        Comparativo de solicitações por departamento.
      </label>
      <div className="h-64">
        {!loading && tamanho > 0 ? (
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="pie"
            height="100%"
          />
        ) : !loading ? (
          "Não existem dados disponíveis para o intervalo selecionado."
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}